import { render, staticRenderFns } from "./CoursesDashboard.html?vue&type=template&id=266a7161&external"
import script from "./CoursesDashboard.js?vue&type=script&lang=js&external"
export * from "./CoursesDashboard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports